/** A client-side stale-request guard, not a substitute for backend authorization. */
export function requireRequestScope(expected, current) {
  if (!expected) return;
  if (!expected.organizationId || !expected.workspaceId || !current.userId
      || expected.organizationId !== current.organizationId || expected.workspaceId !== current.workspaceId)
    throw new Error('Workspace changed; request cancelled');
}
